/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */


require('./bootstrap');
let MobileDetect = require('mobile-detect');
let md = new MobileDetect(window.navigator.userAgent);
if (md.mobile() || md.phone()) {
    window.$mobile = window.$phone = true;
} else if (md.mobile() || md.phone() || md.tablet()) {
    window.$mobile = true;
} else {
    window.$mobile = false;
}
window.Hammer = require('hammerjs');
window.SmartPhoto = require('smartphoto');
window.Vue = require('vue').default;

import {Workbox} from 'workbox-window';

// if ('serviceWorker' in navigator) {
//     const wb = new Workbox('/service-worker.js');
//     wb.register();
// }

